import type { BridgeRequestError } from "@/src/lib/bridge/bridge";
import { parseBridgeErrorPayload } from "@/src/lib/bridge/bridge";

const CANCEL_HINTS = [
  "cancel",
  "cancelled",
  "canceled",
  "user exit",
  "user exited",
  "exit link",
  "link exit",
  "user chose to exit",
];

const normalizeText = (value: unknown): string =>
  typeof value === "string" ? value.trim().toLowerCase() : "";

const textLooksLikeUserCancel = (value: unknown): boolean => {
  const text = normalizeText(value);
  if (!text) {
    return false;
  }
  return CANCEL_HINTS.some((hint) => text.includes(hint));
};

/** 用户主动取消 Plaid（非网络/鉴权失败） */
export const isPlaidUserCanceledError = (error: unknown): boolean => {
  if (error == null) {
    return false;
  }

  const bridgeError =
    parseBridgeErrorPayload(error) ??
    parseBridgeErrorPayload((error as BridgeRequestError).bridgeError);

  if (bridgeError) {
    if (textLooksLikeUserCancel(bridgeError.code)) {
      return true;
    }
    if (textLooksLikeUserCancel(bridgeError.errMsg)) {
      return true;
    }
  }

  if (typeof error === "object" && error !== null) {
    const plaidExit = error as {
      error_code?: unknown;
      error_message?: unknown;
      display_message?: unknown;
    };
    if (textLooksLikeUserCancel(plaidExit.error_code)) {
      return true;
    }
    if (textLooksLikeUserCancel(plaidExit.error_message)) {
      return true;
    }
    if (textLooksLikeUserCancel(plaidExit.display_message)) {
      return true;
    }
  }

  if (
    typeof error === "object" &&
    error !== null &&
    "message" in error &&
    typeof (error as { message: unknown }).message === "string"
  ) {
    return textLooksLikeUserCancel((error as Error).message);
  }

  return textLooksLikeUserCancel(error);
};
